import { Subscribe } from 'unstated';

import PeopleContainer from '~/containers/People';
import ShowPerson from '~/pages/people/components/ShowPerson';

export default class WrappedShowPerson extends React.Component {
  render() {
    const { id: personId } = this.props;
    return (
      <Subscribe to={[PeopleContainer]}>
        {(peopleContainer) => (
          <ShowPerson
            key={personId}
            personId={personId}
            person={peopleContainer.findPerson(personId)}
            fetchPerson={peopleContainer.fetchPerson}
          />
        )}
      </Subscribe>
    );
  }
}
